/* eslint-disable */
import GraphQL from '../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ModifyAccountAccessConnectionDirectionMutationVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
  connectionDirection: GraphQL.AccountAccessConnectionDirection;
}>;


export type ModifyAccountAccessConnectionDirectionMutation = { readonly __typename?: 'Mutation', readonly ModifyAccountAccessConnectionDirection: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly features: ReadonlyArray<{ readonly __typename?: 'AccountFeatureState', readonly feature: GraphQL.AccountFeature, readonly id: CK.ID }> } | null } } };


export const ModifyAccountAccessConnectionDirectionDocument = gql`
    mutation ModifyAccountAccessConnectionDirection($accountId: AccountId!, $connectionDirection: AccountAccessConnectionDirection!) {
  ModifyAccountAccessConnectionDirection(
    accountId: $accountId
    connectionDirection: $connectionDirection
  ) {
    query {
      account(id: $accountId) {
        features {
          feature
          id
        }
        id
      }
    }
  }
}
    `;
export type ModifyAccountAccessConnectionDirectionMutationFn = Apollo.MutationFunction<ModifyAccountAccessConnectionDirectionMutation, ModifyAccountAccessConnectionDirectionMutationVariables>;

/**
 * __useModifyAccountAccessConnectionDirectionMutation__
 *
 * To run a mutation, you first call `useModifyAccountAccessConnectionDirectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyAccountAccessConnectionDirectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyAccountAccessConnectionDirectionMutation, { data, loading, error }] = useModifyAccountAccessConnectionDirectionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      connectionDirection: // value for 'connectionDirection'
 *   },
 * });
 */
export function useModifyAccountAccessConnectionDirectionMutation(baseOptions?: Apollo.MutationHookOptions<ModifyAccountAccessConnectionDirectionMutation, ModifyAccountAccessConnectionDirectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyAccountAccessConnectionDirectionMutation, ModifyAccountAccessConnectionDirectionMutationVariables>(ModifyAccountAccessConnectionDirectionDocument, options);
      }
export type ModifyAccountAccessConnectionDirectionMutationHookResult = ReturnType<typeof useModifyAccountAccessConnectionDirectionMutation>;
export type ModifyAccountAccessConnectionDirectionMutationResult = Apollo.MutationResult<ModifyAccountAccessConnectionDirectionMutation>;
export type ModifyAccountAccessConnectionDirectionMutationOptions = Apollo.BaseMutationOptions<ModifyAccountAccessConnectionDirectionMutation, ModifyAccountAccessConnectionDirectionMutationVariables>;